import { FieldErrors } from "react-hook-form";
import "./styles/FormField.sass";

interface IProps {
    name: string;
    displayName?: string;
    hideLabel?: boolean;
    instructions?: string | undefined;
    placeholder?: string | undefined;
    errors: FieldErrors<any>;
    displayClearButton?: boolean;
    disabled?: boolean;
    children: string | JSX.Element | JSX.Element[];
}

const FormField = ({
    name,
    displayName,
    hideLabel = false,
    instructions,
    errors,
    children,
}: IProps) => {
    function toUpperCase(string: string) {
        return string[0].toUpperCase() + string.slice(1, string.length);
    }
    return (
        <div className="input__wrapper">
            {hideLabel ? (
                ""
            ) : (
                <label
                    id={`${name}-label`}
                    htmlFor={name}
                    className="input__label"
                >
                    {displayName ? displayName : toUpperCase(name)}
                </label>
            )}
            {instructions && <p className="instructions">{instructions}</p>}
            {children}
            {errors !== undefined && errors[name] && (
                <p className="input__error-message" role="alert">
                    {typeof errors[name]!.message == "string"
                        ? (errors[name]!.message as string)
                        : null}
                    {/*@ts-ignore */}
                    {typeof errors[name]!.message.msg == "string"
                        ? //@ts-ignore
                          (errors[name]!.message.msg as string)
                        : null}
                </p>
            )}
        </div>
    );
};
export default FormField;
